var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { createCaseCounter, createCaseSuccess, withCreateCaseLatency, } from '../lib/metrics';
import { log } from '../lib/logger';
import { captureException } from '../lib/sentry';
import { useShowChatboxStore } from '../stores/showChatboxStore';
import { useGetOrCreateSupportCaseRequest } from '../api/useGetOrCreateSupportCaseRequest';
export const useCreateConversation = (lineOfBusiness, clientId, language) => {
    const [, setShowChatbox] = useShowChatboxStore(lineOfBusiness);
    const createConversationRequest = useGetOrCreateSupportCaseRequest(lineOfBusiness, clientId, language);
    const createConversation = useCallback((flowParam, pagesVisited) => __awaiter(void 0, void 0, void 0, function* () {
        yield createCaseCounter(lineOfBusiness);
        try {
            const res = yield withCreateCaseLatency(lineOfBusiness, () => __awaiter(void 0, void 0, void 0, function* () {
                const result = yield createConversationRequest({
                    flow: flowParam,
                    pagesVisited: pagesVisited,
                });
                yield createCaseSuccess(lineOfBusiness);
                return result.getOrCreateSupportCase;
            }));
            setShowChatbox(true);
            return res;
        }
        catch (err) {
            log.error(err);
            captureException(err);
            throw err;
        }
    }), [lineOfBusiness, createConversationRequest, setShowChatbox]);
    return { createConversation };
};
